import DoubleBufferingImage from '@images/graphics/doublebuffering.svg';
import DoubleBufferingVSyncImage from '@images/graphics/doublebufferingvsync.svg';
import TripleBufferingVSyncImage from '@images/graphics/triplebufferingvsync.svg';
import RenderAheadImage from '@images/graphics/renderahead.svg';
import VRRImage from '@images/graphics/vrr.svg';
import * as React from 'react';
export default {
  DoubleBufferingImage,
  DoubleBufferingVSyncImage,
  TripleBufferingVSyncImage,
  RenderAheadImage,
  VRRImage,
  React
};